var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0615 22.873H29.5352V39.8208H45.0615V22.873Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.986 11.0107H29.1211V22.871H39.986V11.0107Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8241 1.72372C29.8241 1.26706 29.6424 0.828092 29.3192 0.504895C28.996 0.181698 28.557 0 28.1004 0C28.0489 0 27.9959 0 27.9444 0C27.4878 0 27.0488 0.181698 26.7256 0.504895C26.4024 0.828092 26.2207 1.26706 26.2207 1.72372C26.2207 9.63642 26.2207 42.0928 26.2207 42.0928H29.8257V1.72372H29.8241Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3754 41.8516C45.3273 41.8516 46.0991 41.0798 46.0991 40.1279C46.0991 40.0764 46.0991 40.0233 46.0991 39.9719C46.0991 39.02 45.3273 38.2482 44.3754 38.2482C39.4985 38.2482 25.9531 38.2482 25.9531 38.2482V41.8532H44.3754V41.8516Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10156 42.094V10.7181C3.10156 7.90904 5.37839 5.63379 8.18587 5.63379C10.4852 5.63379 13.1351 5.63379 15.1547 5.63379C17.0441 5.63379 18.6906 6.92015 19.1489 8.75321C21.3566 17.5792 27.4877 42.094 27.4877 42.094H3.10156Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7093 41.3811C13.9691 37.7254 11.2162 34.5511 7.56038 34.2913C3.90459 34.0314 0.730338 36.7844 0.470492 40.4402C0.210647 44.096 2.96361 47.2702 6.6194 47.5301C10.2752 47.7899 13.4494 45.0369 13.7093 41.3811Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1965 43.0934C12.4043 40.8369 11.554 38.0285 9.29745 36.8207C7.04088 35.6129 4.23248 36.4632 3.02473 38.7198C1.81697 40.9763 2.6672 43.7847 4.92377 44.9925C7.18035 46.2002 9.98874 45.35 11.1965 43.0934Z",
    fill: "#A2C138"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8301 42.9629C31.0233 40.2452 28.9767 37.8855 26.259 37.6923C23.5413 37.4991 21.1816 39.5457 20.9884 42.2634C20.7953 44.9811 22.8418 47.3408 25.5595 47.534C28.2772 47.7271 30.637 45.6806 30.8301 42.9629Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3459 42.8572C29.4808 40.9598 28.0519 39.3123 26.1545 39.1774C24.257 39.0425 22.6095 40.4714 22.4747 42.3688C22.3398 44.2662 23.7686 45.9138 25.6661 46.0486C27.5635 46.1835 29.211 44.7546 29.3459 42.8572Z",
    fill: "#A2C138"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1591 24.7683C23.1591 24.7683 20.1233 12.6316 18.8884 7.69035C18.5861 6.48118 17.5007 5.63379 16.2546 5.63379C13.7816 5.63379 10.0254 5.63379 10.0254 5.63379V18.7964C10.0254 21.9689 12.5643 24.5577 15.7352 24.6204C19.2775 24.6912 23.1591 24.7683 23.1591 24.7683Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7518 22.873H31.7305V28.7485H34.7518V22.873Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7707 11.0117H30.6562V15.1232H32.7707V11.0117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageSystemIcon);
export default __webpack_public_path__ + "static/media/storage-system-icon.1416521c805f21af4560e87eee4905d9.svg";
export { ForwardRef as ReactComponent };